import {Component,Inject} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {LieuService} from "../../lieu.service";
import {Localisation} from "../../../../domain/geolocalisation/localisation";
import {SaveAdresseResult} from "../../../../domain/geolocalisation/saveAdresseResult";
import {Geographie} from "../../../../domain/geolocalisation/geographie";
import {ToastrService} from "ngx-toastr";
import {Adresse} from "../../../../domain/profil/adresse";
import {LieuParam} from "@domain/common/lieu/lieu-param";
import {GeolocalisationToolResult} from "../../lieu-geolocalisation.service";

@Component({
    templateUrl: './lieu-geolocalisation-list.component.html',
    host:{'data-test-id':'lieu-geocalisation-list'},
})
export class LieuGeolocalisationListComponent {
    /** Flag permettant de savoir si un chargement http est en cours */
    isLoading: boolean;

    /** Liste des adresses issues du service de géolocalisation suite à une saisie */
    listeGeolocalisation: Array<Localisation> = null;

    /**
     * Constructeur
     */
    constructor(private lieuService: LieuService,
                private toastrService: ToastrService,
                private translateService: TranslateService,
                private matDialogRef: MatDialogRef<LieuGeolocalisationListComponent,GeolocalisationToolResult>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    adresse: Adresse,
                    geolocalisation: Localisation,
                    lieuParam: LieuParam,
                }) {

        //Début du chargement
        this.isLoading = true;

        //Récupération de la liste des adresses géolocalisées trouvées à partir de la saisie
        this.lieuService.getListeLocalisation(this.data.geolocalisation).subscribe((listeLocalisation) => {
            //Mise à jour des objets retournés
            listeLocalisation.forEach((geolocalisation) => {
                //Définition de la rue (ajout du numéro)
                geolocalisation.rue = geolocalisation.numero ? geolocalisation.numero + ' ' + geolocalisation.rue : geolocalisation.rue;

                //Reconstruction de l'adresse pour afficher le même format que les établissements et adresses perso/pro
                geolocalisation.adresse = this.lieuService.getAdresseFromLocalisation(geolocalisation);
            });

            //Mise à jour de la liste des suggestions et affichage
            this.listeGeolocalisation = listeLocalisation;

            //Fin du chargement
            this.isLoading = false;
        });

    }

    /**
     * Sélection d'une adresse géolocalisée
     *
     * @param geolocalisation Géolocalisation sélectionnée
     */
    public selectLocalisation(geolocalisation: Localisation): void {
        //Paramètres pour l'enregistrement de l'adresse
        const adresse: Localisation = {
            ...(this.data.adresse ?? {}),
            ...geolocalisation,
            listeVisibilite: this.data.lieuParam.listeVisibiliteLocalisation,
            origine: this.data.lieuParam.origineLocalisation,
            idUser: this.data.lieuParam.idUser ?? undefined
        } as Localisation;

        //Début de l'enregistrement
        this.isLoading = true;

        //Enregistrement d'une adresse à partir de la géolocalisation sélectionnée
        this.lieuService.saveAdresse(new Adresse(adresse)).subscribe((result: SaveAdresseResult) => {
            //Fin de l'enregistrement
            this.isLoading = false;

            //Récupération de l'objet geographie associé à l'adresse enregistrée
            const geographie: Geographie = result.geographie;

            //Vérifie si l'adresse est complète
            if (geographie
                && (geographie.entiteGeo?.libelle || this.data.lieuParam.isGeolocaliserWithoutRue)
                && geographie.entiteGeo?.libelleVille
                && geographie.entiteGeo?.libellePays) {
                    //Mise à jour de l'adresse du lieu
                    this.selectAutre({
                        id: geographie.id,
                        adresse: geolocalisation.adresse,
                        rue: geographie.entiteGeo?.libelle,
                        codePostal: geographie.entiteGeo?.codePostal,
                        ville: geographie.entiteGeo?.libelleVille,
                        pays: geographie.entiteGeo?.libellePays,
                        codePays: geographie.entiteGeo?.codePays2,
                        codePays3: geographie.entiteGeo?.codePays3,
                        latitude: geographie.entiteGeo?.latitude,
                        longitude: geographie.entiteGeo?.longitude,
                    });
            } else if (geographie
                && (!geographie.entiteGeo?.libelle || !geolocalisation.rue)
                && !this.data.lieuParam.isGeolocaliserWithoutRue) {
                //Si on a une adresse sans rue alors que le paramètre ne le permet pas
                this.toastrService.warning(this.translateService.instant("lieu.adresseSelectionIncomplete"));
                this.close();
            } else if (geographie) {
                //Une adresse a été sélectionnée, mais elle est incomplète : retour à la saisie
                this.toastrService.warning(this.translateService.instant("lieu.adresseNonGeolocalisee"));
                this.close();
            } else {
                //Pas d'adresse trouvée : retour à la saisie
                this.toastrService.error(this.translateService.instant("lieu.aucuneAdresseGeoloc"));
                this.close();
            }
        });
    }

    /**
     * Fermeture de la popup
     */
    close(): void {
        this.matDialogRef.close();
    }

    /**
     * Envoie la géolocalisation sélectionnée au parent pour traitement
     *
     * @param geolocalisation Géolocalisation sélectionnée
     */
    selectAutre(geolocalisation: Localisation): void {
        this.matDialogRef.close({
            geolocalisation: geolocalisation
        });
    }

}
